import script from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDrawer.vue?vue&type=style&index=0&id=d081c6c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d081c6c8"]])

export default __exports__